
// react-dropzone 14.3 started adding ./ to the file path for some reason
export function parseFileNameType(file: string) {
	const temp = file.split("/");
	const fullFileName = temp[temp.length - 1];
	const temp2 = fullFileName.split(".");
	const fileType = temp2[temp2.length - 1];
	const fileName = fullFileName.replace(`.${fileType}`, "");

	return { fileName, fileType };
}
